import {
  call,
  takeEvery,
  takeLatest,
  delay,
  all,
  put,
} from "redux-saga/effects";
import {
  savedVtParamMap,
  fetchedVtParamMap,
  storeSearchVtParamMapResult,
} from "./actions";
import axios from "axios";
import { handlError, parseError } from "../../app/serverError";
import { URL, getHeaderJWT } from "../../../store/path";
import userACL from "../../../store/access";
import { merge } from "lodash";

function* createVtParamMap() {
  yield takeEvery("CREATE_VTPARAMMAP", saveVtParamMap);
}

function* saveVtParamMap(action) {
  const { response, error } = yield call(saveVtParamMapAPI, action.payload);
  if (response) {
    const data = response.data || {};
    if (data.type === 'error') {
      const msg = data.data || data.msg || data.message || 'Save failed.';
      yield put(savedVtParamMap(action.payload, 'error', msg));
    } else {
      yield put(savedVtParamMap(action.payload, 'success', data.msg || data.data || 'Saved successfully.'));
    }
  } else {
    yield put(handlError(action, parseError(error)));
    sagaErrorMessage(error, action);
  }
}

async function saveVtParamMapAPI(data) {
  try {
    const response = await axios.post(
      URL + "/master/vtparam/add",
      data,
      getHeaderJWT(),
      { crossDomain: true }
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

function* editVtParamMap() {
  yield takeEvery("EDIT_VTPARAMMAP", saveEditedVtParamMap);
}

function* saveEditedVtParamMap(action) {
  const { response, error } = yield call(editVtParamMapAPI, action.payload);
  if (response) {
    const data = response.data || {};
    if (data.type === 'error') {
      const msg = data.data || data.msg || data.message || 'Update failed.';
      yield put(savedVtParamMap(action.payload, 'error', msg));
    } else {
      yield put(savedVtParamMap(action.payload, 'success', data.msg || data.data || 'Updated successfully.'));
    }
  } else {
    yield put(handlError(action, parseError(error)));
    sagaErrorMessage(error, action);
  }
}

async function editVtParamMapAPI(data) {
  let id = data.ID;
  try {
    const response = await axios.post(
      URL + "/master/vtparam/update/" + id,
      data,
      getHeaderJWT(),
      { crossDomain: true }
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

function* deleteVtParamMap() {
  yield takeEvery("DELETE_VTPARAMMAP", saveDeleteVtParamMap);
}

function* saveDeleteVtParamMap(action) {
  const { response, error } = yield call(deletedVtParamMap, action.payload);
  if (response)
    yield put(deletedVtParamMap({ id: action.payload.id, msg: response.data }));
  else {
    yield put(handlError(action, parseError(error)));
    sagaErrorMessage(error, action);
  }
}

async function deletedVtParamMap(data) {
  let vtParamMapId = data.id;
  try {
    const response = await axios.post(
      URL + "/vtparam/delete/" + vtParamMapId,
      data,
      getHeaderJWT(),
      { crossDomain: true }
    );
    return { response };
  } catch (error) {
    return { error };
  }
}

function* fetchVtParamMap() {
  yield takeEvery("FETCH_VTPARAMMAP", requestVtParamMap);
}

function* requestVtParamMap() {
  let { data } = yield call(requestVtParamMapAPI);
  yield put(fetchedVtParamMap(data));
}

function requestVtParamMapAPI(data) {
  data = merge({}, data, userACL.atFetch());
  return axios.post(URL + "/master/vtparam/list", data, getHeaderJWT(), {
    crossDomain: true,
  });
}

function* searchVtParamMap() {
  yield takeLatest("SEARCH_VTPARAMMAP", initiateSearch);
}

function* initiateSearch(action) {
  yield delay(350);
  let { data } = yield call(searchAPI, action.payload);
  yield put(storeSearchVtParamMapResult(data));
}

function searchAPI(data) {
  return axios.post(URL + "/vtparam/search/" + data, data, getHeaderJWT(), {
    crossDomain: true,
  });
}

const sagaErrorMessage = (error, action) => {
  console.group("Saga Error:" + action.type);
  console.log(error);
  console.groupEnd();
};

export default function* vtParamMapSaga() {
  yield all([
    createVtParamMap(),
    fetchVtParamMap(),
    editVtParamMap(),
    deleteVtParamMap(),
    searchVtParamMap(),
  ]);
}
